<div class="page">
  <router-outlet></router-outlet>
</div>

<ng-container *appShellNoSSR>
  @defer (on idle) {
    <app-toast-message></app-toast-message>

    <app-sticky-bonus></app-sticky-bonus>
  }

  @if (!translations.loaded()) {
    <div class="language-preloader">
      <div class="language-preloader__bar"></div>
    </div>
  }

  @if (installApp.showInstallAppAfterDepositBanner() && installApp.isEnableNativeApp()) {
    <app-install-app-banner></app-install-app-banner>
  }

</ng-container>

<img loading="lazy" src="/assets/svg/top.svg" class="to-top-btn" [ngClass]="{'visible': toTopVisible()}" (click)="onToTopClick()">

<ng-container *appShellNoSSR>
  @defer (when gameIframe.isShowFrame()) {
    <app-game-iframe ></app-game-iframe>
  }
</ng-container>
